import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Stack
} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";

export default function LangGlobe({ lang, handleChangeLanguage, client }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (value) => {
    handleChangeLanguage(value);
    handleClose();
  };

  return (
    <>
      {/* BUTTON */}
      <IconButton onClick={handleOpen}>
        <Stack direction="row" spacing={0.5}>
          <LanguageIcon
            sx={{ color: client.chatbot_system_color || "#000" }}
          />
          <Typography
            variant="caption"
            sx={{ color: client.chatbot_system_color || "#000" }}
          >
            {lang?.toUpperCase()}
          </Typography>
        </Stack>
      </IconButton>

      {/* DROPDOWN */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
      >
        {["fr", "en"].map((key) => (
          <MenuItem key={key} onClick={() => handleSelect(key)}>
            {key.toUpperCase()}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
